import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import "./styles/global.scss"

async function bootstrap() {
  // The simulator and its adapter are excluded from production builds.
  if (import.meta.env.DEV && import.meta.env.VITE_LOCAL_GAME_DEMO === '1') {
    const { installLocalLobby } = await import('./dev/localLobby');
    await installLocalLobby();
  }
  createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
  )
}
void bootstrap();
